export default __webpack_public_path__ + "static/nar-bruker-vi-ikoner-45c928a21589c830d21033a9743ebf1f.png";